import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { trackEvent } from '../utils/analytics';
import { webinarSessions } from '../data/webinarCommunications';

/**
 * TEMPORARY promo bar for the Communications ATNA client training.
 * To remove it: set ANNOUNCEMENT_ENABLED to false.
 */
export const ANNOUNCEMENT_ENABLED = true;
export const ANNOUNCEMENT_HEIGHT = 50;
const COPY = {
  FR: {
    badge: 'Nouveau',
    title: 'Formation clients — Communications ATNA',
    short: 'Formation',
    cta: 'S’inscrire'
  },
  EN: {
    badge: 'New',
    title: 'Client Training — Communications ATNA',
    short: 'Training',
    cta: 'Register'
  }
};
export function AnnouncementBar() {
  const {
    lang
  } = useLanguage();
  const key = lang === 'EN' ? 'EN' : 'FR';
  const c = COPY[key];
  const session = webinarSessions[key];

  // The header is fixed: offset page content by the bar height while the bar is shown.
  useEffect(() => {
    if (!ANNOUNCEMENT_ENABLED) return;
    const prev = document.body.style.paddingTop;
    document.body.style.paddingTop = `${ANNOUNCEMENT_HEIGHT}px`;
    return () => {
      document.body.style.paddingTop = prev;
    };
  }, []);
  if (!ANNOUNCEMENT_ENABLED) return null;
  return <Link to="/formation-communications" onClick={() => trackEvent('announcement_click', {
    target: 'formation-communications',
    session: session.id
  })} aria-label={`${c.title} — ${session.barDate} — ${c.cta}`} className="group block bg-[#0B0F26] text-white border-b border-white/[0.06]" style={{
    height: ANNOUNCEMENT_HEIGHT
  }} data-id="element-493" data-mp="18nh7ndgf6ux">
      <div className="max-w-[1400px] h-full mx-auto px-3 sm:px-6 flex items-center justify-center gap-2 sm:gap-4 lg:gap-5 font-sans whitespace-nowrap" data-id="element-494" data-mp="f6u64e0fdwig">
        <span className="shrink-0 inline-flex items-center rounded-full bg-[#4F46E5] px-2 sm:px-2.5 py-[3px] text-[9.5px] sm:text-[10.5px] font-semibold tracking-[0.12em] uppercase" data-id="element-495" data-mp="17xcbjlomg9z1">
          {c.badge}
        </span>

        {/* Desktop */}
        <span className="hidden lg:inline text-[15px] font-semibold tracking-[-0.005em] text-white" data-id="element-496" data-mp="1mi892lj7gr3r">{c.title}</span>
        <span className="hidden lg:inline text-white/25" aria-hidden="true" data-id="element-497" data-mp="1hjeragwvydxs">·</span>

        {/* Tablet + desktop: full date */}
        <span className="hidden sm:inline-flex items-center gap-2 text-[14.5px] font-semibold text-[#C7C4FF]" data-id="element-498" data-mp="18l2yq9cgl62p">
          <CalendarIcon className="w-4 h-4" aria-hidden="true" data-id="element-499" data-mp="13mi5itvmjmnr" />
          {session.barDate}
        </span>

        {/* Mobile */}
        <span className="sm:hidden min-w-0 truncate text-[12.5px] font-semibold text-white" data-id="element-500" data-mp="ytfbkkmxqb71">
          {c.short} · <span className="text-[#C7C4FF]" data-id="element-501" data-mp="ttkiqbjlnbjc">{session.barShort}</span>
        </span>

        <span className="shrink-0 sm:ml-2 inline-flex items-center gap-1.5 h-8 sm:h-9 rounded-full bg-white px-3 sm:px-4 text-[12px] sm:text-[13px] font-semibold uppercase tracking-[0.06em] text-[#0B0F26] transition-colors duration-150 group-hover:bg-[#EEEDFD]" data-id="element-502" data-mp="oy59jwwje3t9">
          {c.cta}
          <ArrowRightIcon className="w-3.5 h-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-503" data-mp="2ri68zcb7o5mw" />
        </span>
      </div>
    </Link>;
}